module.exports = {
    set: set,
    get: get,
    remove: remove
}

function set(name, value) {
    document.cookie = name + "=" + (value || "") + "; domain=" + process.env.AppSettings.cookieDomain + "; path=/";
}
function get(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function remove(name) {
    if (get(name)) {
        set(name, "", -1);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/app/my-settings/shared/cookieManager.js
// module id = 448
// module chunks = 0